import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const STAGES = ["Detected", "Validated", "Confirmed", "Remediation", "Retest", "Resolved"];

// Detected -> Validated -> Confirmed -> Remediation -> Retest -> Resolved stepper.
const VaptTimeline = ({ timeline = [] }) => {
  const reached = new Set(timeline.map((t) => t.stage));
  const lastReachedIdx = STAGES.reduce((idx, stage, i) => (reached.has(stage) ? i : idx), -1);

  return (
    <div>
      <div className="flex items-center">
        {STAGES.map((stage, i) => {
          const done = i <= lastReachedIdx;
          const entry = timeline.find((t) => t.stage === stage);
          return (
            <React.Fragment key={stage}>
              <div className="flex flex-col items-center text-center w-20">
                <div
                  className={`w-7 h-7 rounded-full flex items-center justify-center border-2 ${
                    done ? "bg-primary-600 border-primary-600" : "bg-white border-gray-300"
                  }`}
                >
                  {done && <CheckCircleIcon className="w-5 h-5 text-white" />}
                </div>
                <p className={`text-[11px] mt-1.5 font-medium ${done ? "text-gray-800" : "text-gray-400"}`}>{stage}</p>
                {entry && <p className="text-[10px] text-gray-400">{new Date(entry.date).toLocaleDateString()}</p>}
              </div>
              {i < STAGES.length - 1 && (
                <div className={`flex-1 h-0.5 -mt-5 ${i < lastReachedIdx ? "bg-primary-600" : "bg-gray-200"}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {timeline.length > 0 && (
        <div className="mt-6 space-y-2">
          {timeline.map((t, i) => (
            <div key={i} className="flex items-center justify-between text-xs border-b border-gray-100 pb-2">
              <span className="font-medium text-gray-700">{t.stage}</span>
              <span className="text-gray-400">
                {new Date(t.date).toLocaleString()} {t.by ? `• ${t.by}` : ""}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VaptTimeline;
